export const GetErrorMessage = (error: any) => {
  // if (
  //   error?.status === "403" ||
  //   error?.response?.status === 403 ||
  //   error?.code === "auth/invalid-custom-token" ||
  //   error?.response?.data?.error?.code === "auth/invalid-custom-token"
  // ) {
  //   localStorage.removeItem("token");
  //   setInterval(() => {
  //     window.location.replace("/login");
  //   }, 3000);
  //   return "กรุณาเข้าสู่ระบบใหม่อีกครั้ง";
  // }
  if (error === undefined) return "Error!";
  return (
    error.response?.data?.error?.message ||
    error.response?.data?.error?.code ||
    error.response?.data?.message ||
    error.message ||
    error
  );
};
